export const EDITOR = 'EDITOR'
export const EDITOR_RESPONSIVE = 'RESPONSIVE'
export const ADI = 'ADI'
export const ADI_TEMPLATE = 'ADI_TEMPLATE'
export const APP_MARKET = 'APP_MARKET'
